import React from 'react';
const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="footer mx-auto">
            <div className='footer-text'><h6>COPYRIGHT  &copy; {currentYear /*2024  <a href="#">*/} NEXT GEN EDUCATION</h6>{/*</a>*/}  </div>
        </footer>
    )
};

export default Footer;